import { FormPicker } from 'ui/components';
import { postFormWithId } from 'application/repositories/formRepository';

export const FormPickerFeature: React.FC<Content.FormPicker> = ({ content }) => {
	return <FormPicker properties={content.properties.form} postFormWithId={postFormWithId}  />;
};
